import React, { useState, useEffect, useCallback } from 'react';
import { API, apiFetch } from '../api';

const TYPE_META = {
  login_success:  { label: 'Login OK',   bg: '#e8f5e9', color: '#2e7d32' },
  login_fail:     { label: 'Login Fail', bg: '#fff3e0', color: '#e65100' },
  login_locked:   { label: 'Locked',     bg: '#fce4ec', color: '#c62828' },
  login_blocked:  { label: 'Blocked',    bg: '#fce4ec', color: '#c62828' },
  otp_sent:       { label: 'OTP Sent',   bg: '#e3f2fd', color: '#1565c0' },
  otp_fail:       { label: 'OTP Fail',   bg: '#fff3e0', color: '#e65100' },
  submission_approved: { label: 'Approved',  bg: '#e8f5e9', color: '#2e7d32' },
  submission_declined: { label: 'Declined',  bg: '#fce4ec', color: '#c62828' },
  user_approved:  { label: 'User OK',    bg: '#e8f5e9', color: '#2e7d32' },
  user_rejected:  { label: 'User Rej.',  bg: '#fce4ec', color: '#c62828' },
  user_unlocked:  { label: 'Unlocked',   bg: '#e3f2fd', color: '#1565c0' },
};

const s = {
  page:    { padding: '20px 16px 40px', maxWidth: '700px', margin: '0 auto' },
  heading: { fontSize: '20px', fontWeight: '700', color: '#222', marginBottom: '4px' },
  sub:     { fontSize: '13px', color: '#888', marginBottom: '20px' },

  tabs: { display: 'flex', gap: '8px', marginBottom: '20px' },
  tab: {
    padding: '8px 18px', borderRadius: '20px', fontSize: '13px',
    fontWeight: '600', border: '1.5px solid #e0e0e0',
    background: '#fff', color: '#888', cursor: 'pointer',
  },
  tabActive: {
    background: '#DB3267', color: '#fff', border: '1.5px solid #DB3267',
  },

  row: {
    display: 'flex', alignItems: 'flex-start', gap: '10px',
    padding: '10px 14px', borderBottom: '1px solid #f5f5f5',
    fontSize: '13px',
  },
  pill: {
    display: 'inline-block', padding: '2px 9px', borderRadius: '20px',
    fontSize: '11px', fontWeight: '700', flexShrink: 0, marginTop: '1px',
  },
  meta:   { color: '#aaa', fontSize: '11px', marginTop: '2px' },
  detail: { color: '#555', marginTop: '2px' },
  user:   { fontWeight: '700', color: '#222' },
  empty:  { textAlign: 'center', padding: '50px 20px', color: '#bbb', fontSize: '14px' },
  card:   { background: '#fff', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.06)', overflow: 'hidden' },
};

function formatDate(str) {
  if (!str) return '';
  return str.replace('T', ' ').slice(0, 16);
}

function TypePill({ type }) {
  const m = TYPE_META[type] || { label: type, bg: '#f5f5f5', color: '#555' };
  return (
    <span style={{ ...s.pill, background: m.bg, color: m.color }}>{m.label}</span>
  );
}

export default function AdminLogs() {
  const [tab, setTab]         = useState('login');
  const [logs, setLogs]       = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async (t) => {
    setLoading(true);
    const res  = await apiFetch(`${API}/logs?type=${t}`);
    const data = await res.json();
    if (data.ok) setLogs(data.logs);
    setLoading(false);
  }, []);

  useEffect(() => { load(tab); }, [tab, load]);

  function switchTab(t) {
    setTab(t);
    setLogs([]);
  }

  return (
    <div style={s.page}>
      <h1 style={s.heading}>Activity Logs</h1>
      <p style={s.sub}>Security audit trail — last 500 events per category</p>

      <div style={s.tabs}>
        <button
          style={{ ...s.tab, ...(tab === 'login' ? s.tabActive : {}) }}
          onClick={() => switchTab('login')}
        >
          Login Attempts
        </button>
        <button
          style={{ ...s.tab, ...(tab === 'general' ? s.tabActive : {}) }}
          onClick={() => switchTab('general')}
        >
          General Activity
        </button>
      </div>

      <div style={s.card}>
        {loading ? (
          <div style={s.empty}>Loading...</div>
        ) : logs.length === 0 ? (
          <div style={s.empty}>No events yet</div>
        ) : (
          logs.map(log => (
            <div key={log.id} style={s.row}>
              <TypePill type={log.type} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div>
                  {log.username
                    ? <span style={s.user}>{log.username}</span>
                    : <span style={{ color: '#bbb' }}>unknown</span>
                  }
                </div>
                {log.detail && <div style={s.detail}>{log.detail}</div>}
                <div style={s.meta}>
                  {formatDate(log.created_at)}
                  {log.ip && ` · ${log.ip}`}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
